
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapActions, mapMutations, mapState } from 'vuex';

import { ClaimCheck } from '@/models';
import AppInput from '@/components/AppInput.vue';
import MarkdownText from '@/components/MarkdownText.vue';

@Component({
	components: {
		AppInput,
		MarkdownText,
	},
	computed: {
		...mapState('claimCheck', ['claimCheck']),
	},
	methods: {
		...mapMutations('claimCheck', ['setRewardsDescription']),
		...mapActions('claimCheck', ['sendMembership']),
	},
})
export default class MembershipModal extends Vue {
	@Prop()
	public titleText!: string;

	@Prop()
	public displayText!: string;

	@Prop()
	public required!: boolean;

	public card: string = '';
	public claimCheck!: ClaimCheck;
	public confirm: boolean = false;
	public confirm_text: string = '';
	public error_message: string = '';
	public request!: {
		card: string;
		confirm: boolean;
	};

	public sendMembership!: (payload: any) => Promise<any>;

	public get content(): string {
		return this.displayText || 'If you have a membership or rewards account, enter your card value here to associate it with your claim check.';
	}

	public async handleRequest() {
		const payload = {
			...this.request,
			card: this.card,
			confirm: this.confirm,
			ticket: this.claimCheck.ticket,
			url: `/claim/${this.claimCheck.ticket}/membership`,
		};

		try {
			this.error_message = '';
			const response = await this.sendMembership(payload);

			if (response && response.requested_time) {
				this.$emit('requested', response.requested_time);
			}

			this.$modal.hide('MembershipModal');
			window.location.reload();
		} catch (error: any) {
			this.error_message = error.response.data[0].text;
		}
	}

	public async removeRate() {
		const payload = {
			...this.request,
			card: '',
			ticket: this.claimCheck.ticket,
			skip: true,
			url: `/claim/${this.claimCheck.ticket}/membership`,
		};

		try {
			this.error_message = '';
			const response = await this.sendMembership(payload);

			if (response && response.requested_time) {
				this.$emit('requested', response.requested_time);
			}

			this.$modal.hide('MembershipModal');
			window.location.reload();
		} catch (error: any) {
			this.error_message = error.response.data[0].text;
		}
	}

	public get isValid(): boolean {
		if (!this.card) {
			return false;
		}

		return true;
	}
}
